// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectEntitlementProductDocumentResponseMessage } from "../../../../Utils/DirectMessages/DirectMessagesImport.ts";
import { EntitlementDocumentGroup } from "../Groups/GroupsImport.js"
export let EntitlementProductDocumentResponseMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

EntitlementProductDocumentResponseMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

EntitlementProductDocumentResponseMessageProcessor.prototype.decode = function (fs)
{
    let msg = new DirectEntitlementProductDocumentResponseMessage()
    let ff = FieldsFactory

    let documents = fs.GetGroups(FieldsFactory.DOCUMENT_GROUP)

    let len = documents ? documents.length : 0
    for (let i = 0; i < len; i++)
    {
        let document = new EntitlementDocumentGroup(documents[i])
        msg.AddDocument(document.GetDoucument())
    }

    return [msg]
}